import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/lj/workspace/bold/site/src/components/mdx/MDXPageLayout";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "about-us",
      "style": {
        "position": "relative"
      }
    }}>{`About us`}</h1>
    <p>{`Bridge is a laboratory integrated into the Technological Center (CTC) of the Federal University of Santa Catarina
(UFSC), that works with research and development of technological solutions connecting government and citizen
through innovation.`}</p>
    <p><img parentName="p" {...{
        "src": "/image/team.jpg",
        "alt": "Bridge Team"
      }}></img></p>
    <h2 {...{
      "id": "what-we-value",
      "style": {
        "position": "relative"
      }
    }}>{`What we value`}</h2>
    <p>{`As an organization and individuals, we respect society, as well as employees, partners, the academic community,
customers and all those we impact. We work to achieve results with simplicity, not leaving aside the constant
search for creativity and technological innovation. Our commitment is to contribute positively to society,
always giving value to ethics and transparency in projects. Most importantly, we are passionate and committed to
people and technology. With humility, we take on challenges by encouraging the whole team to work together, to
achieve the highest quality, agility, and excellence.`}</p>
    <h2 {...{
      "id": "our-development-process",
      "style": {
        "position": "relative"
      }
    }}>{`Our development process`}</h2>
    <p>{`We carried out an extensive search for references to develop our components and were inspired by various design systems, mainly the `}<a href="https://www.carbondesignsystem.com/">{`Carbon Design System`}</a>{` and `}<a href="https://atlassian.design/">{`Atlassian Design`}</a>{`, as well as the `}<a href="https://www.nngroup.com">{` NN Group`}</a>{` usability recommendations.
During the development stage, we also discussed the components with developers and business analysts from various Laboratório Bridge products to cover as many use cases as possible. `}<strong parentName="p">{`The components and results of this project were also tested with users to measure and meet the usability criteria.`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      